var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"md-card",staticStyle:{"border":"0","min-height":"400px","margin-top":"15px","width":"100%"},attrs:{"title":"Ahja perearstikabineti asukoht","src":_vm.location,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }